import { MATCH_ID_PATTERN } from 'Lib/constants/ids';

import { HOMEPAGE_INTL_ROUTE_REGEX } from './static';

const PREFIX_CAMPAIGN = '/c';
const PREFIX_MATCHES = '/matches';
const PREFIX_MESSAGE = '/messages';
const PREFIX_PROFILE = '/profile';
const PREFIX_PROFILE_EDIT = `${PREFIX_PROFILE}/edit`;
const PREFIX_RECS = '/recs';
const PREFIX_SETTINGS = '/settings';
const PREFIX_VERIFY = '/verify';
const PREFIX_EXPLORE = '/explore';

const ROUTES = {
  // App prefix
  prefix: '/app',
  // App routes
  accountSettings: `${PREFIX_SETTINGS}/account`,
  addCard: `${PREFIX_SETTINGS}/add-card/:returnPage`,
  appealsCenter: '/appeals-center',
  deeplinkConfirm: '/deeplink/:type/confirm/:otp',
  deeplinkRemoveEmail: '/link/account-email/remove/:otp',
  deeplinkToGold: '/getGold',
  deeplinkNavigate: '/deeplink/navigate/:route',
  deeplinkToIncentives: '/vip/:promoCode',
  deeplinkToCampaign: '/campaigns/:campaignInfo/:otp',
  deeplinkToAgeVerification: '/deeplink/age-verification/:status',
  campaign: `${PREFIX_CAMPAIGN}/:name`,
  checkout: '/checkout',
  connectedAccountsSettings: `${PREFIX_SETTINGS}/connected-accounts`,
  explore: PREFIX_EXPLORE,
  exploreCuratedRecs: `${PREFIX_EXPLORE}/:catalogId`,
  editProfile: PREFIX_PROFILE_EDIT,
  editProfileGender: `${PREFIX_PROFILE_EDIT}/gender`,
  editProfileGenderSearch: `${PREFIX_PROFILE_EDIT}/gender/search`,
  editProfileLivingIn: `${PREFIX_PROFILE_EDIT}/living-in`,
  editProfileInterests: `${PREFIX_PROFILE_EDIT}/interests`,
  editProfileOptions: `${PREFIX_PROFILE_EDIT}/:option`,
  editProfileOrientation: `${PREFIX_PROFILE_EDIT}/orientation`,
  editProfilePrompts: `${PREFIX_PROFILE_EDIT}/prompts`,
  editProfileSelectAnthem: `${PREFIX_PROFILE_EDIT}/anthem`,
  editProfileSelectTopArtists: `${PREFIX_PROFILE_EDIT}/top-artists`,
  editProfileSelectSchool: `${PREFIX_PROFILE_EDIT}/school`,
  editProfileStickers: `${PREFIX_PROFILE_EDIT}/sticker`,
  emailAccountSettings: `${PREFIX_SETTINGS}/email-account`,
  emailNotificationSettings: `${PREFIX_SETTINGS}/email`,
  exListAddContact: `${PREFIX_SETTINGS}/add-contacts`,
  exListSettings: `${PREFIX_SETTINGS}/block-contacts/:tab(tab-contacts|tab-blocked)`,
  phoneAccountSettings: `${PREFIX_SETTINGS}/phone-account`,
  readReceiptSettings: `${PREFIX_SETTINGS}/read-receipts`,
  recentlyActiveSettings: `${PREFIX_SETTINGS}/recently-active`,
  error: '/error',
  emailRemove: '/email-remove',
  gift: '/gift',
  giftCard: '/giftcard',
  giftCardRedeem: '/giftcard/redeem',
  goldHome: '/gold-home',
  globalModeLanguagePreferences: `${PREFIX_SETTINGS}/global/languages`,
  levers: `${PREFIX_SETTINGS}/levers`,
  likesYou: '/likes-you',
  login: '/',
  loginLegacy: '/login',
  matches: PREFIX_MATCHES,
  matchExpirationArchived: `${PREFIX_MATCHES}/archived`,
  messageControlsSettings: `${PREFIX_SETTINGS}/message-controls`,
  messageDataConsentSettings: `${PREFIX_SETTINGS}/message-data-consent`,
  messageMatch: `${PREFIX_MESSAGE}/:matchId(${MATCH_ID_PATTERN})`,
  messageMatchProfile: `${PREFIX_MESSAGE}/:matchId(${MATCH_ID_PATTERN})/profile`,
  mmProfile: `/matchmaker/:id(${MATCH_ID_PATTERN})/profile`,
  mmEntry: `/matchmaker/:id(${MATCH_ID_PATTERN})`,
  mutualFriendsSettings: `${PREFIX_SETTINGS}/friends-of-friends`,
  myLikes: '/my-likes',
  onboarding: '/onboarding',
  biometrics: '/biometrics',
  passport: `${PREFIX_SETTINGS}/plus/passport`,
  preCheckout: '/product/subscription/:productType',
  preferencesDescriptorSelection: `${PREFIX_SETTINGS}/preference/:descriptorId`,
  preferencesInterestsSelection: `${PREFIX_SETTINGS}/preference/interests`,
  privacy: `${PREFIX_SETTINGS}/privacy`,
  profile: PREFIX_PROFILE,
  profilePreview: `${PREFIX_PROFILE}/preview`,
  promo: '/promo',
  pushNotificationSettings: `${PREFIX_SETTINGS}/push`,
  remote: '/remote',
  recs: PREFIX_RECS,
  recsProfile: `${PREFIX_RECS}/profile`,
  selfieChallenge: `${PREFIX_VERIFY}/identity`,
  selfieChallengeV2: '/v2/identity',
  settings: PREFIX_SETTINGS,
  stacksUtil: `${PREFIX_SETTINGS}/stacks-util`,
  subscriptionSettings: `${PREFIX_SETTINGS}/subscription`,
  emailSubscriptionService: '/email-subscription',
  subSetting: `${PREFIX_SETTINGS}/:subSetting(distance|gender|language)`,
  tinderUSettings: `${PREFIX_SETTINGS}/tinderu`,
  tinderSelect: `/select`,
  updateCard: `${PREFIX_SETTINGS}/update-card/:returnPage`,
  vault: '/vault',
  vaultFeatures: '/vault/features',
  verify: `${PREFIX_VERIFY}/:reason`,
  warden: '/:tier(banned|underReview|bcBanned|customBanScreen)',
  webProfile: '/@:username',
  webProfileSettings: `${PREFIX_SETTINGS}/web-profile`,
  international: HOMEPAGE_INTL_ROUTE_REGEX,
  selectPreCheckout: '/select/subscription',
  selectCheckout: '/select/checkout',
};

export type Route = keyof typeof ROUTES;

export type RoutesConfig = {
  routes: Record<Route, string>;
};

const routesConfig = [
  {
    settings: ['main'] as const,
    routes: ROUTES,
  },
];

export default routesConfig;
